import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { DISCHARGE_MODE, HEALTH_CONDITION } from '../../../../../constants';
import { dateFormatter } from '../../../../../utils';
import { CustomButtonn } from '../../../../../components/Input/CustomButton';
import { useLocation } from 'react-router-dom';

const DETAIL_HEADER = [
  {
    header: 'Patient Name',
    accessor: (row) => `${row.patient.name_suffix} ${row.patient.first_name} ${row.patient.last_name ? row.patient.last_name:"" }`
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'IPD No',
    accessor: 'ipd_no'
  },
  {
    header: 'Doctor Name',
    accessor: 'consultant_detail.doctor.name'
  },
  {
    header: 'Sponsor',
    accessor: 'patient.sponsor.name'
  }
];

const TABLE_HEADER = [
  {
    header: 'UHID NO',
    accessor: 'uhid'
  },
  {
    header: 'IPD No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Patient Name',
   accessor: (row)=> `${row?.patient?.name_suffix} ${row?.patient?.first_name} ${row?.patient?.last_name ? row?.patient?.last_name :""}`
  },
  {
    header: 'Ward',
    accessor: (row)=> row?.consultant_detail?.room?.ward?.name
  },
  {
    header: 'Bed No',
    accessor: (row)=> row?.consultant_detail?.bed_no
  },

];

const initialIndoorRegisterationDataObj = {
  data: [],
  loading: false
};

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
export const PatientDischargeRequest = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialIndoorRegisterationDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [patientData, setPatientData] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));
  console.log('HELLLO USERS', user);
  const isEnabledDate =
    user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;

  console.log('HELLO isEnable', isEnabledDate);

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5)
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const formSubmit = async (formValue) => {
    try {
      const response = await request('/patient-discharge-request', {
        method: 'PUT',
        params: formValue.ipd_no
      });
      if (response?.success) {
        toast(`Successfully ${'created'} Patient Discharge Request`, { variant: 'success' });
        setSelectedRecord(response?.data);
        setCurrentAction();
        searchIPDDetails();
        reset();
      } else {
        toast(`Failed to ${'create'} Patient Discharge Request`, { variant: 'error' });
      }
    } catch (error) {
      toast(`An error occurred: ${error.message}`, { variant: 'error' });
    }
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/patient-discharge-delete', {
      method: 'DELETE',
      params: selectedRecord._id, // This should be a part of the URL, not params
      body: {
        ipd_no: selectedRecord.ipd_no,
        bed_no: selectedRecord.bed_no // Ensure bed_no is sent to the backend
      }
    });

    if (response?.success) {
      toast('Successfully deleted Patient Discharge', { variant: 'success' });
      setSelectedRecord();
      searchIPDDetails();
    } else {
      toast('Failed to delete Patient Discharge', { variant: 'error' });
    }

    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setIndoorRegisterationDataObj({ loading: true });
    const query = {
      name : "requested_discharge"
    };
    const response = await request('/indoor-registeration-status', { method: 'GET',query : query });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
      const filteredData = sortedData.filter((item) => item.admission_status === 'requested_discharge');
      setIndoorRegisterationDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  };
  useEffect(() => {
    if (indoorRegisterationDataObj.data && indoorRegisterationDataObj.data.length > 0) {
      setOriginalData(indoorRegisterationDataObj.data);
      setIsFiltered(false);
    }
  }, [indoorRegisterationDataObj.data]);

  const handleUhidSearch = () => {
    const filtered = indoorRegisterationDataObj.data.filter(
      (item) => item.uhid.toString().includes(input) || (item.ipd_no && item.ipd_no.toString().includes(input))
    );
    setOriginalData(filtered);
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
    handleUhidSearch();
  };

  useEffect(() => {
    if (detailList && detailList.length > 0) {
      setPatientData(detailList);
      setIsFiltered(false);
    }
  }, [detailList]);

  const handlePatientSearch = () => {
    const filtered = detailList.filter(
      (item) =>
        item.patient.first_name === input ||
        item.uhid.toString().includes(input) ||
        (item.ipd_no && item.ipd_no.toString().includes(input))
    );
    setPatientData(filtered);
  };

  const handlePatientChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
    handlePatientSearch();
  };

  useEffect(() => {
    searchIPDDetails();
  }, []);

  useEffect(()=>{
    searchIPDDetails()
  } ,[input])

  const searchIPDDetails = async () => {
    setLoading(true);
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const query = {
        name : "admit"
      };
      if (lowercasedInput) {
        query.patientName = lowercasedInput;
      }
      const response = await request('/indoor-registeration-status', {
        method: 'GET',
        query:query
      });

      if (response?.success) {
        if (!response?.data || response.data.length === 0) {
          toast('No IPD found', { variant: 'warning' });
        } else {
          const sortedData = response.data
            .filter((patient) => patient.admission_status === 'admit')
            .sort((a, b) => new Date(b.date) - new Date(a.date));
          setDetailList(sortedData);
          setPatientData(sortedData);
        }
      } else {
        toast('Failed to load patient details', { variant: 'error' });
      }
    } catch (error) {
      toast('An error occurred while fetching patient details', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, '', ['_id', 'status', '__v']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date', formattedDate);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const handleCancelRequest = async () => {
    setLoading(true);
    const response = await request('/patient-discharge-request-cancel', {
      method: 'PUT',
      params: selectedRecord.ipd_no, // This should be a part of the URL, not params
      body: {
        ipd_no: selectedRecord.ipd_no
      }
    });
    if (response?.success) {
      toast('Successfully deleted Patient Discharge', { variant: 'success' });
      setSelectedRecord();
      searchIPDDetails();
    } else {
      toast('Failed to delete Patient Discharge', { variant: 'error' });
    }
    setLoading(false);
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Patient Discharge Request
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRequest();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box sx={{ padding: 2, borderRadius: '8px', width: '80%', boxShadow: '0px 2px 10px #0099ff' }}>
              <Grid container spacing={2}>
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Grid item xs={12} sx={{ display: 'flex', minHeight: '40rem', flexDirection: 'column', gap: 0.3 }}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
                      <MuiTextField
                        sx={{
                          width: '100%',
                          '& .MuiOutlinedInput-root': {
                            padding: '0'
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '8px 14px',
                            fontSize: '1.5rem' // Increase input font size here
                          },
                          '& .MuiInputLabel-root': {
                            fontSize: '1.5rem' // Increase label font size here
                          }
                        }}
                        label="Search Patient"
                        variant="outlined"
                        value={input}
                        onChange={handlePatientChange}
                      />
                    </Stack>
                    <Table
                      disabled
                      containerSX={{ flex: 1 }}
                      data={(currentAction === 'new' && patientData) || []}
                      columns={DETAIL_HEADER}
                      size="small"
                      onRowClick={(row) => {
                        const {
                          patient: {
                            name_suffix,
                            first_name,
                            last_name,
                            sponsor: { name: sponsorName }
                          },
                          consultant_detail: { bed_no, room },
                          ...otherDetails
                        } = row;

                        if (!room || !room._id) {
                          console.error('Room data is missing or undefined');
                          return;
                        }

                        const {
                          room_no,
                          ward: { name: wardName }
                        } = room;

                        setSelectedRecord({
                          ...otherDetails,
                          patient_name: `${name_suffix} ${first_name} ${last_name}`,
                          sponsor: sponsorName,
                          bed_no: bed_no,
                          room: room_no,
                          ward_name: wardName,
                          room_id: room._id, // Capture room_id here for later use
                          date: new Date().toISOString().split('T')[0],
                          time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5)
                        });

                        setOpenQueryDialog(false);
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ display: 'flex', gap: 0.2, flexDirection: 'column', boxShadow: '0px 0px 2px #0099ff' }}
                >
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Date/Time</Typography>
                    <TextField
                      sx={{ flex: 0.5 }}
                      name="date"
                      type="date"
                      placeholder="Date"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                    <TextField
                      sx={{ flex: 0.4 }}
                      name="time"
                      type="time"
                      placeholder="Time"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>

                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Doc No.</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} placeholder="Doc No." name="doc_no" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Ipd No.</Typography>
                    <TextField sx={{ flex: 0.8 }} placeholder="Ipd No." name="ipd_no" disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Uhid No.</Typography>
                    <TextField sx={{ flex: 0.8 }} disabled name="uhid" placeholder="Uhid No." />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <TextField sx={{ flex: 0.8 }} name="patient_name" disabled placeholder="Patient Name" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} placeholder="Sponsor" name="sponsor" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Ward No.</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} placeholder="Ward Name" name="ward_name" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Room/Bed</Typography>
                    <TextField disabled sx={{ flex: 0.4 }} placeholder="Room No." name="room" />
                    <TextField disabled sx={{ flex: 0.4 }} placeholder="Bed No." name="bed_no" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Discharge Mode</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      placeholder="Discharge Mode"
                      name="discharge_mode"
                      menus={DISCHARGE_MODE}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Health Condition</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      placeholder="Health Condition"
                      name="health_condition"
                      menus={HEALTH_CONDITION}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      placeholder="Remarks"
                      name="remarks"
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Patient Discharge Request Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={indoorRegisterationDataObj?.data || []}
          loading={indoorRegisterationDataObj.loading}
          onRowClick={(row) => {
            const {
              patient: {
                name_suffix,
                first_name,
                last_name,
                sponsor: { name: sponsorName }
              },
              consultant_detail: { bed_no, room },
              ...otherDetails
            } = row;

            if (!room || !room._id) {
              console.error('Room data is missing or undefined');
              return;
            }

            const {
              room_no,
              ward: { name: wardName }
            } = room;

            setSelectedRecord({
              ...otherDetails,
              patient_name: `${name_suffix} ${first_name} ${last_name}`,
              sponsor: sponsorName,
              bed_no: bed_no,
              room: room_no,
              ward_name: wardName,
              room_id: room._id, // Capture room_id here for later use
              date: new Date().toISOString().split('T')[0],
              time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5)
            });

            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
